@import '../../scss/mixin';

.context {
  z-index: 10000;
  position: relative;
  max-height: var(--popover-available-height);
  min-width: 140px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;

  overflow: auto;
  overscroll-behavior: contain;
  outline: none !important;

  border-radius: 4px;
  border: 1px solid #E6E0D7;
  background: #FFF;
  color: #28292B;
}

.title {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.5px;

  outline: none !important;
}

.items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.item {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.5px;

  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  scroll-margin: 8px;
  outline: none !important;
  color: #68696B;
  cursor: pointer;

  &:hover {
    color: #28292B;
  }

  &[aria-disabled=true] {
    opacity: 0.25;
  }

  &[data-active-item=true] {
    color: #28292B;
  }

  /*
  &:active,
  &[data-active=true] {
    color: #28292B;
  }
  */
}

.options {
  @include btn();
}
